import {keys} from '../../api/keys';
import {FontStorageState} from '../../interfaces/screens/fontChanger';
import lightTheme from '../../theme/lightTheme';

const safeParse = (value: string | null) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

/**
 * Retrieves the local data stored with the specified key.
 */
export const getLocalData = (key: string): any | null => {
  try {
    const value = localStorage.getItem(key);
    return safeParse(value);
  } catch {
    return null;
  }
};

/**
 * Stores the specified value in localStorage with the given key.
 */
export const setLocalData = (key: string, value: any): boolean => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};

/**
 * Clears all data in localStorage.
 */
export const flushLocalData = (): boolean => {
  try {
    localStorage.clear();
    return true;
  } catch {
    return false;
  }
};

/**
 * Updates the stored font settings.
 */
export const updateFont = (data: FontStorageState): boolean => {
  try {
    localStorage.setItem(keys.FONT, JSON.stringify(data));
    return true;
  } catch {
    return false;
  }
};

/**
 * Retrieves stored font settings.
 */
export const getFont = (): FontStorageState => {
  try {
    const raw = localStorage.getItem(keys.FONT);
    if (!raw) throw new Error('Missing font data');

    return JSON.parse(raw);
  } catch {
    return {
      fontWeight: 'normal',
      item: {
        value: 2,
        label: '20',
        textSize: lightTheme.text.s55,
      },
      fontSize: lightTheme.text.s55,
    };
  }
};

/**
 * Removes a key-value pair from storage.
 * @param {string} key - The key to remove.
 * @returns {boolean} - True if successful, false otherwise.
 */
export const remove = (key: string): boolean => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (err) {
    return false;
  }
};

